import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { ServerRepresentedEvent } from '@app/modules/events/models/event.model'
import { Persona } from '@app/modules/personas/interfaces/persona.interface'
import { isKnownSocialMediaUrl } from '@app/v2/event/utils/is-known-social-media-url'
import { ISocial } from '../../../model/social-media.model'
import { EventTimesComponent } from '../event-times/event-times.component'
import { LandingTimerComponent } from '../landing-timer/landing-timer.component'
import { LandingShareComponent } from '../share/landing-share.component'

@Component({
  selector: 'ngx-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss'],
  imports: [CommonModule, LandingShareComponent, EventTimesComponent, LandingTimerComponent]
})
export class LandingHeaderComponent implements OnInit {
  @Input() event: ServerRepresentedEvent
  @Input() persona: Persona
  @Input() isLandingPage = true
  @Input() isInvitation = false
  socials: ISocial[] = []
  public readonly isKnownSocialMediaUrl = isKnownSocialMediaUrl

  ngOnInit(): void {
    const socialMedia = Array.isArray(this.event?.social_media) ? this.event.social_media : []
    this.socials = socialMedia.filter((social) => !!social?.url).map(({ url, icon, title }) => ({ url, icon, title }))
  }

  /**
   * Gets cover-page photo for landing-header
   * @returns string
   */
  get getCoverPhoto(): string {
    return this.event?.cover_page ? `url(${this.event?.cover_page})` : `url(https://library.micetribe.com/icons/default_cover.svg)`
  }
}
